<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Benutzer bearbeiten
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
      <v-card class="stepperSearchWrapper">
        <v-container class="stepperSearchContainer">
          <span>Benutzer suchen</span>
          <v-text-field class="searchCbx"
                        append-icon=""
                        outlined
                        dense
                        hide-details
                        placeholder="Benutzerdaten..."
                        v-model="searchField"
                        :search-input.sync="search"
                        no-filter
          >
          </v-text-field>
        </v-container>
      </v-card>

      <v-container v-if="!isLoading">
        <v-row class="editUserStepper">
          <v-col cols="12"
              v-for="user in filteredResults"
                 :key="user.uid"
          >
            <v-card class="marketWrapper">
              <v-container>
                <span class="marketName" style="width: 100%;">{{ user.lastName }}, {{ user.firstName }}</span>
                <span class="customerId" style="width: 100%;">{{ user.uid}}</span>
                <PermissionCheckbox style="width: 100%;" text="CSV-Import Warenkorb aktivieren" :code="'CSVIMPORT'" @valueChanged="valueChangedPermission($event, user.id)" :data="user.permissions && user.permissions.findIndex(el => el.code === 'CSVIMPORT') > -1"/>
                <PermissionCheckbox style="width: 100%;" text="Produkt-Standardansicht" :code="'PRODSTANDARD'" @valueChanged="valueChangedPermission($event, user.id)" :data="user.permissions && user.permissions.findIndex(el => el.code === 'PRODSTANDARD') > -1"/>
                <PermissionCheckbox style="width: 100%;" text="Lager" :code="'LAGER'" @valueChanged="valueChangedPermission($event, user.id)" :data="user.permissions && user.permissions.findIndex(el => el.code === 'LAGER') > -1"/>
                <v-btn class="resetUserPwBtn"
                       @click="resetPw(user.uid)"
                >
                  Passwort zurücksetzen
                </v-btn>
                <v-btn class="deleteUserBtn"
                       @click="deleteUser(user.uid)"
                >
                  <TrashCan/>
                </v-btn>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <VSnackbars :messages.sync="messages" :timeout="timeoutDuration" bottom class="stackableNotificationSnackbar">
        <template v-slot:default="{message}">
          <span>{{ message }}</span>
        </template>
        <template v-slot:action="{ close }">
          <close-btn @click="close()" style="margin-right: 10px;"/>
        </template>
      </VSnackbars>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import axios from 'axios'
import TrashCan from "@/assets/cart/trashCan";
import router from '@/router'
import PermissionCheckbox from "@/app/utils/PermissionCheckbox.vue";
import VSnackbars from "v-snackbars"
import CloseBtn from "@/assets/closeBtn.vue";
export default {
  name: "editUser",
  components: {CloseBtn, PermissionCheckbox, TrashCan, VSnackbars},
  data:() => {
    return {
      userData: null,
      isLoading : true,
      searchField: '',
      filteredResults: null,
      search: null,
      timeoutDuration: 3000,
      showNotification: false,
      notificationText: null,
      messages: []
    }
  },
  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility'
    }),
    ...mapActions('users', ['updateUser']),
    valueChangedPermission(data, userId) {
      // temp set to permission 1 as only 1 permission is given
      let params = {
        permission: 1,
        value: data.value,
        userId: userId,
        code: data.code
      }
      let index = this.filteredResults.findIndex(el => el.id === userId)
      if(index > -1) {
        let item = this.filteredResults[index]
        item['permissions'].push({code: data.code})
        this.filteredResults.splice(index, 1, item)
        // do also on userData
      }
      this.updateUser(params).then(response => {
        if(response.status === 1) {
          this.messages.push('Eintrag erfolgreich bearbeitet.')
          // this.notificationText = 'Eintrag erfolgreich bearbeitet.'
          // this.showNotification = true
        } else if (response.status === -1) {
          this.messages.push('Fehler beim Bearbeiten des Eintrages.')
          // this.notificationText = 'Fehler beim Bearbeiten des Eintrages.'
          // this.showNotification = true
        }
        let index = this.filteredResults.findIndex(el => el.id === userId)
        if(index > -1) {
          this.filteredResults.splice(index, 1, response.data)
          // do also on userData
        }
      })
    },

    goBack() {
      router.go(-1)
    },

    getUsers() {
      axios.get('/api/getUsers')
        .then((response) => {
          this.userData = response.data
          this.filteredResults = this.userData
          this.isLoading = false
        })
    },

    filterUsers(val) {
      this.filteredResults = []
      this.userData.forEach((obj) => {
        if(obj.uid.includes(val) ||
            obj.lastName.toLocaleLowerCase().includes(val.toLocaleLowerCase()) ||
            obj.firstName.toLocaleLowerCase().includes(val.toLocaleLowerCase())
        )
        {
          this.filteredResults.push(obj)
        }
      })
    },

    resetPw(user) {
      let params = {user: user}
      axios.post('api/resetPassword', params)
        .then(() => {
        })
    },

    deleteUser(user) {
      let params = {user: user}
      axios.post('api/deleteUser', params)
          .then((result) => {
            this.userData = result.data
            this.filteredResults = result.data
          })
    }
  },

  created() {
  this.setHeaderVisibility(false)
    this.getUsers()
  },
  computed: {
    ...mapGetters({
      getShowNotification: 'getShowNotification',
      getNotificationTxt: 'getNotificationTxt',
    }),
  },
  watch: {
    searchField() {
      this.filterUsers(this.searchField)
    },
    showNotification: {
      handler(state) {
        if(state) {
          setTimeout(() => {
            this.showNotification = false
          }, this.timeoutDuration)
        }
      }
    }
  }
}


</script>

<style>

.editUserStepper .col {
  padding: 0px;
}

.editUserStepper .col:first-child{
  margin-bottom: 16px;
}

.editUserStepper .col:last-child{
  margin-top: 16px;
  margin-bottom: 25px;
}

.editUserStepper .col:not(:first-child):not(:last-child) {
  margin: 16px 0px;
}

.resetUserPwBtn {
  margin-left: auto;
  position: absolute;
  background-color: var(--igros-red)!important;
}

.resetUserPwBtn.theme--light.v-btn {
  min-height: 20px;
}

.deleteUserBtn {
  margin-right: auto;
  position: absolute;
  bottom: -20px;
  right: 30px;
  background-color: #939393!important;
}

.deleteUserBtn.theme--light.v-btn {
  min-height: 20px;
}

.deleteUserBtn #Rechteck_7 {
  fill: transparent;
}

.marketWrapper .customerId {
  margin-bottom: 15px;
}
</style>
